import { SavStatus } from '@/models/savV2';

// Phase 3: Flags prioritaires sur stateId pour les statuts 3/4/6
export interface AwaitingFlags {
  awaitingBeneficiary?: boolean;
  awaitingManager?: boolean;
  awaitingGarant?: boolean;
}

export function getSavStatusLabelForBeneficiary(stateId?: SavStatus, flags?: AwaitingFlags): string {
  // Flags prioritaires
  if (flags?.awaitingBeneficiary) return 'En attente de votre action';
  if (flags?.awaitingManager || flags?.awaitingGarant) return 'En cours de traitement';

  // Fallback stateId (hors anciens statuts 3/4/6 gérés par les flags)
  switch (stateId) {
    case SavStatus.TEMPORAIRE:
      return 'En cours de création';
    case SavStatus.NOUVEAU:
      return 'Déclaration reçue';
    case SavStatus.A_PRENDRE_EN_CHARGE:
      return 'En cours de traitement';
    case SavStatus.LITIGE:
      return 'En cours d\'examen';
    case SavStatus.PRIS_EN_CHARGE:
      return 'Pris en charge';
    case SavStatus.SANS_SUITE:
      return 'Clôturé sans suite';
    default:
      return 'En cours';
  }
}

export function getSavStatusColorClass(stateId?: SavStatus, flags?: AwaitingFlags): string {
  // Flags prioritaires
  if (flags?.awaitingBeneficiary) return 'tw-bg-orange-100 tw-text-orange-700';
  if (flags?.awaitingManager || flags?.awaitingGarant) return 'tw-bg-blue-100 tw-text-blue-700';

  // Fallback stateId (hors anciens statuts 3/4/6 gérés par les flags)
  switch (stateId) {
    case SavStatus.TEMPORAIRE:
      return 'tw-bg-gray-100 tw-text-gray-700';
    case SavStatus.NOUVEAU:
      return 'tw-bg-blue-100 tw-text-blue-700';
    case SavStatus.A_PRENDRE_EN_CHARGE:
      return 'tw-bg-blue-100 tw-text-blue-700';
    case SavStatus.LITIGE:
      return 'tw-bg-yellow-100 tw-text-yellow-700';
    case SavStatus.PRIS_EN_CHARGE:
      return 'tw-bg-green-100 tw-text-green-700';
    case SavStatus.SANS_SUITE:
      return 'tw-bg-gray-100 tw-text-gray-700';
    default:
      return 'tw-bg-gray-100 tw-text-gray-700';
  }
}

export function getSavStatusIcon(stateId?: SavStatus, flags?: AwaitingFlags): string {
  // Flags prioritaires
  if (flags?.awaitingBeneficiary) return 'faExclamationCircle';

  // Fallback stateId (hors anciens statuts 3/4/6 gérés par les flags)
  switch (stateId) {
    case SavStatus.PRIS_EN_CHARGE:
      return 'faCheckCircle';
    case SavStatus.LITIGE:
      return 'faExclamationTriangle';
    case SavStatus.SANS_SUITE:
      return 'faTimesCircle';
    default:
      return 'faInfoCircle';
  }
}

export function shouldShowUrgentNotice(_stateId?: SavStatus, flags?: AwaitingFlags): boolean {
  // Flags uniquement
  if (flags?.awaitingBeneficiary !== undefined) return flags.awaitingBeneficiary;

  return false;
}

export function getSavStatusLabel(stateId?: SavStatus, flags?: AwaitingFlags): string | null {
  // Flags prioritaires
  if (flags?.awaitingBeneficiary) return 'En attente bénéficiaire';
  if (flags?.awaitingManager) return 'En attente gestionnaire';
  if (flags?.awaitingGarant) return 'En attente garant';

  // Fallback stateId (hors anciens statuts 3/4/6 gérés par les flags)
  switch (stateId) {
    case SavStatus.TEMPORAIRE:
      return 'Temporaire';
    case SavStatus.NOUVEAU:
      return 'Nouveau';
    case SavStatus.LITIGE:
      return 'Litige';
    case SavStatus.A_PRENDRE_EN_CHARGE:
      return 'À prendre en charge';
    case SavStatus.PRIS_EN_CHARGE:
      return 'Pris en charge';
    case SavStatus.SANS_SUITE:
      return 'Sans suite';
    default:
      return null;
  }
}
